{
  "mineTitle": "My activity",
  "mineLead": "Your registrations and tickets, and the reports you sent.",
  "myRegistrations": "My registrations",
  "upcoming": "Upcoming",
  "past": "Past",
  "noUpcoming": "You have no upcoming registrations.",
  "noPast": "No past registrations yet.",
  "findPrograms": "Find programs open for registration",
  "signInForRegistrations": "Sign in to see your registrations and tickets. Reports you sent from this phone are listed below.",
  "attended": "Attended",
  "waitlistNo": "Waitlist #{position}",
  "followingLead": "Posts from what you follow fill your \"For you\" feed, and you get notified when they post.",
  "followingNone": "You're not following anything yet. Start with your barangay and the offices you deal with.",
  "municipalOffices": "Municipal offices",
  "barangays": "Barangays",
  "barangay": "Barangay",
  "municipalOffice": "Municipal office",
  "topics": "Topics",
  "followBarangayHint": "Posts for residents of these barangays, and from their barangay offices.",
  "followTopicHint": "Posts in these categories, from any office.",
  "pushTitle": "Notifications on this phone",
  "pushLead": "New posts from what you follow, registration updates and reminders the day before.",
  "pushTurnOff": "Turn off notifications",
  "pushOff": "Notifications are off on this phone.",
  "notificationsLead": "Updates from offices you follow and about your registrations.",
  "notificationsEmpty": "No notifications yet",
  "notificationsEmptyBody": "Follow offices and register for programs; updates will appear here.",
  "markAllRead": "Mark all as read",
  "unread": "Unread",
  "officesLead": "Every municipal office and barangay that posts here. Open one to see its schedules and contact details.",
  "searchOffices": "Search offices and barangays",
  "noOffices": "No offices are listed yet.",
  "noOfficeMatch": "No office matches your search.",
  "allOffices": "All offices",
  "officeNotFound": "We couldn't find that office.",
  "aboutOffice": "About",
  "contactTitle": "Contact and office hours",
  "noContact": "This office hasn't added its contact details yet.",
  "location": "Location",
  "officeHours": "Office hours",
  "phone": "Phone",
  "otherContact": "Other contact",
  "officePosts": "Posts and schedules",
  "officeNoPosts": "No current posts",
  "officeNoPostsBody": "This office has no current schedules, programs or announcements.",
  "officeNoPostsFollow": "This office has no current posts. Follow it to be notified when it posts."
}
